import React from 'react'
import VisibilitySensor from '../../../Components/VisibilitySensor';
import { getEventLabel } from './../../helpers/gtag-helpers';

export default  ({ index, name, label, category, nonInteraction, children }) => {
  const eventLabel = getEventLabel(label, index);

  const handleVisible = () => {
    gtag('event', name, {
      'event_label': eventLabel,
      'event_category': category,
      'non_interaction': nonInteraction,
    });
  }

  return (
      <VisibilitySensor onVisible={handleVisible}>
        {children}
      </VisibilitySensor>
  );
};
